import { render, staticRenderFns } from "./HotelManager.vue?vue&type=template&id=28168914"
import script from "./HotelManager.vue?vue&type=script&lang=js"
export * from "./HotelManager.vue?vue&type=script&lang=js"
import style0 from "./HotelManager.vue?vue&type=style&index=0&id=28168914&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports